import { Form, Field } from 'mobx-react-form';
import { DropdownFieldBase } from 'core/components';
import dvr from 'mobx-react-form/lib/validators/DVR';
import validatorjs from 'validatorjs';

class FormBase extends Form {
	constructor(hooks) {
		super(
			{},
			{
				hooks,
				options: {
					validationDebounceWait: 50,
				},
			}
		);
	}

	plugins() {
		return {
			dvr: dvr({
				package: validatorjs,
				extend: ({ validator }) => {
					var messages = validator.getMessages('en');
					messages.required = 'MESSAGES.REQUIRED.:attribute';
					messages.email = 'MESSAGES.EMAIL.:attribute';
					messages.min.string = 'MESSAGES.MIN.:attribute';
					messages.max.string = 'MESSAGES.MAX.:attribute';
					messages.same = 'MESSAGES.SAME.:attribute';
					messages.different = 'MESSAGES.DIFFERENT.:attribute';
					messages.between = 'MESSAGES.BETWEEN.:attribute';
					messages.numeric = 'MESSAGES.NUMERIC.FILTER.NUMBER';
					messages.integer = 'MESSAGES.INTEGER.:attribute';
					messages.min.numeric = 'MESSAGES.MIN.:attribute';
					validator.setMessages('en', messages);
				},
			}),
		};
	}
}

export default FormBase;



// WEBPACK FOOTER //
// ./src/core/components/forms/base/FormBase.js